'use strict';

var blocksToHyperScript = require('@sanity/block-content-to-hyperscript');

var h = blocksToHyperScript.renderNode;
var blocksToHtml = function blocksToHtml(options) {
  var rootNode = blocksToHyperScript(options);
  return rootNode.outerHTML || rootNode;
};

blocksToHtml.defaultSerializers = blocksToHyperScript.defaultSerializers;
blocksToHtml.getImageUrl = blocksToHyperScript.getImageUrl;
blocksToHtml.renderNode = h;
blocksToHtml.h = h;

module.exports = blocksToHtml;
//# sourceMappingURL=blocksToHtml.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sanity/block-content-to-html/lib/blocksToHtml.js
// module id = 254
// module chunks = 0